/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to copy recovery code" |
*
* @param {Auth_Recovery_Code_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_copy_failed = /** @type {((inputs?: Auth_Recovery_Code_Copy_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_Copy_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Kopieren des Wiederherstellungscodes")
	return /** @type {LocalizedString} */ ("Failed to copy recovery code")
});